module.exports = __webpack_public_path__ + "static/media/DesignIcon.4db97b36.svg";